<template>
  <div class="developing">
    준비중입니다.
  </div>
</template>
<script>
export default {
  mounted() {
    this.$eventHub.$emit('content-loaded')
  }
}
</script>
